import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import InfoReceiver from "sockjs-client/lib/info-receiver";

export function createWebSocketClient({ url, subscriptions = [], onConnect, onError }) {
    InfoReceiver.timeout = 60000; // 60 секунд
    const client = new Client({
        webSocketFactory: () => new SockJS(url),
        reconnectDelay: 5000,
        onConnect: (frame) => {
            if (onConnect) onConnect(frame);

            subscriptions.forEach(({ destination, callback }) => {
                client.subscribe(destination, callback);
            });
        },
        onStompError: (frame) => {
            console.error('STOMP Error:', frame.headers['message']);
            if (onError) onError(frame);
        }
    });

    return client;
}